import React from 'react';
import { ArrowLeft } from 'lucide-react';

const SitePrivacy = ({ onBack }) => (
    <div className="legal-page">
        <div className="legal-container">
            <button className="legal-back" onClick={onBack}>
                <ArrowLeft size={20} />
                Back to Home
            </button>

            <h1>Website Privacy Policy</h1>
            <p className="legal-updated">Last Updated: February 20, 2026</p>

            <p>
                This Privacy Policy describes how <strong>EagleTap SRL</strong> ("we", "us", "our")
                collects, uses, and protects information when you visit our website
                at <strong>www.eagletap.com</strong> (the "Website").
            </p>

            <h2>1. Information We Collect</h2>
            <p>
                Our Website is designed with a privacy-first approach. We collect minimal information:
            </p>
            <ul>
                <li>
                    <strong>No personal data</strong>: We do not require registration, login, or
                    any form submission that collects personal information to browse the Website.
                </li>
                <li>
                    <strong>Technical data</strong>: Our hosting provider may automatically log
                    standard technical data such as your IP address, browser type, and pages visited
                    for security and performance purposes. This data is not used for tracking or profiling.
                </li>
                <li>
                    <strong>Local storage</strong>: We use your browser's local storage to remember
                    your language preference and dark/light mode setting. This data never leaves your device.
                </li>
            </ul>

            <h2>2. Cookies</h2>
            <p>
                This Website does <strong>not use cookies</strong> for analytics, advertising, or tracking.
                No third-party cookies are set by visiting our Website.
            </p>

            <h2>3. Third-Party Services</h2>
            <p>
                The Website does not integrate any third-party analytics, advertising, or social media
                tracking services. We use Google Fonts for typography, which may result in a connection
                to Google's servers to load font files.
            </p>

            <h2>4. Links to External Sites</h2>
            <p>
                Our Website may contain links to external sites such as the Apple App Store and
                Google Play Store. We are not responsible for the privacy practices of these external sites.
                We encourage you to review their privacy policies.
            </p>

            <h2>5. Children's Privacy</h2>
            <p>
                Our Website does not knowingly collect any personal information from children.
                The Website is an informational site about our educational products.
            </p>

            <h2>6. Data Controller</h2>
            <p>
                The data controller is <strong>EagleTap SRL</strong>, based in Italy.
                For any privacy-related questions, contact us at: <strong>privacy@eagletap.com</strong>.
            </p>

            <h2>7. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be posted on this
                page with an updated revision date.
            </p>
        </div>
    </div>
);

export default SitePrivacy;
